import React from "react";

const LashesInJakkurCustomer = () => {
  return (
    <div className="hairSalonInJakkurCustomer">
      <h5>Client Experiences</h5>
      <p>
        Our clients love the results they achieve with our Eye Lashes in Jakkur
        services. Here are some testimonials from satisfied customers:
      </p>
      <div className="hairSalonInJakkurCustomerContent">
        <p>
          <span className="quote">“</span>I had lash extensions done at SCENT,
          and I couldn’t be happier! The technician was so skilled and made sure
          I was comfortable the entire time. My lashes look amazing, and I’ve
          received so many compliments. I highly recommend SCENT for Eye Lashes
          in Jakkur. <span className="quote">”</span> - <span>Sarah T. </span>
        </p>
        <p>
          <span className="quote">“</span>The lash lift and tint I got at SCENT
          was exactly what I needed. My natural lashes look so much longer and
          fuller now. The process was quick and easy, and the results are
          fantastic. This is definitely the best place for Eye Lashes in Jakkur.
          <span className="quote">”</span> - <span>John R . </span>
        </p>
      </div>
    </div>
  );
};

export default LashesInJakkurCustomer;
